import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryUnits } from '@/renderer/services/inventoryItemService';

export function useInventoryUnits(companyId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.inventory.units(companyId ?? 0),
    queryFn: async () => {
      const result = await fetchInventoryUnits(companyId ?? 0);
      if (!result.success) {
        throw new Error(result.error ?? 'Failed to fetch inventory units');
      }

      return result.data ?? [];
    },
    enabled: !!companyId,
  });
}
